import React, { createContext } from 'react';
/** @public */
export var ContentfulContext = createContext({});
/** @public */
var ContentfulProvider = function (_a) {
    var contentful = _a.contentful, children = _a.children;
    return React.createElement(ContentfulContext.Provider, { value: contentful }, children);
};
ContentfulProvider.displayName = 'ContentfulProvider';
ContentfulContext.displayName = 'ContentfulContext';
export default ContentfulProvider;
//# sourceMappingURL=ContentfulProvider.js.map